import { makeAutoObservable } from 'mobx'
import { ExpenseItemDto } from 'api-client'
import { Effect } from './utils/Effect'
import { RequestHelper } from './utils/RequestHelper'
import ApiClient from '../api'
import { AreasStore } from './areas.store'
import { authenticationService } from '../auth/authenticationService'

class DailySummaryStoreClass {
  constructor() {
    makeAutoObservable(this)
  }

  submitEffect = new Effect((request) =>
    RequestHelper.unwrapFromFetchResponse(
      ApiClient().dailySummaries.postApiV1DailySummaries(request),
      'Daily summary saved'
    )
  )

  submit = (items: ExpenseItemDto[], notes: string, summaryDate: string) =>
    this.submitEffect.run({
      items,
      notes,
      summaryDate,
      areaId: AreasStore.selectedAreaId,
    })

  // CSV-эндпойнт отдаёт файл, а не типизированный DTO, поэтому качаем ручным fetch → Blob.
  // eslint-disable-next-line class-methods-use-this
  downloadCsv = async (from: string, to: string) => {
    // eslint-disable-next-line @typescript-eslint/dot-notation
    const base = process.env['REACT_APP_API_BASE_URL']
    const token = authenticationService.getToken()

    const response = await fetch(`${base}/api/v1/reports/daily-summaries/csv`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        from,
        to,
        areaId: AreasStore.selectedAreaId,
      }),
    })

    if (!response.ok) {
      throw new Error(`CSV download failed: ${response.status}`)
    }

    const blob = await response.blob()
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = `daily-summaries_${from.slice(0, 10)}_${to.slice(0, 10)}.csv`
    document.body.appendChild(link)
    link.click()
    link.remove()
    URL.revokeObjectURL(url)
  }
}

export const DailySummaryStore = new DailySummaryStoreClass()
